define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var PhoneNumberModel = /** @class */ (function () {
        function PhoneNumberModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.CustomerName = ko.observable();
            this.Number = ko.observable();
            this.BTN = ko.observable();
            this.HasE911 = ko.observable(false);
            this.E911Details = ko.observableArray([]);
            this.CNam = ko.observable();
            this.SmsProEnabled = ko.observable(false);
            this.SmsEnabled = ko.observable(false);
            this.SmsOnlyLoa = ko.observable(false);
            this.PhoneNumberProviderId = ko.observable();
            this.OfficeLocationId = ko.observable();
            this.PhoneNumberStatusId = ko.observable();
            this.PhoneNumberTypeId = ko.observable();
            this.CustomerEditReadonly = ko.observable(true);
            this.NumberEditReadonly = ko.observable(true);
            this.Comment = ko.observable('');
            this.CommentHtml = ko.observable('');
            this.PhoneNumberProviderName = ko.observable();
            this.OfficeLocationName = ko.observable();
            this.PhoneNumberStatusName = ko.observable();
            this.PhoneNumberTypeName = ko.observable();
            this.EntityName = ko.observable();
            this.AllowSipToSip = ko.observable(2);
            this.AllowAnonymousCid = ko.observable(false);
            this.GroupId = ko.observable();
            this.DeleteAlias = ko.observable(false);
            this.CampaignInternalId = ko.observable();
            this.BrandInternalId = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, PhoneNumberModel.Mapping, self);
            }
        }
        PhoneNumberModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new PhoneNumberModel(options.data);
            }
        };
        return PhoneNumberModel;
    }());
    return PhoneNumberModel;
});
//# sourceMappingURL=PhoneNumberModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/PhoneNumberModel.js
// module id = 79
// module chunks = 2